import { useGlobalAlias } from '@/common/hook/useGlobalAlias';
import React from 'react';

export const CollectListContext = React.createContext<any>(null);
export const SemirModelCode = 'senma_resource_mall_model_20250828';

/** 地图视角-枚举 */
export enum MapView {
  /** 全国视角 */
  National = 1,
  /** 省份视角 */
  Province = 2,
  /** 市视角 */
  City = 3,
}
/** 地图视角-选项 */
export const mapViews = [
  { value: MapView.National, label: '全国视角' },
  { value: MapView.Province, label: '省份视角' },
  { value: MapView.City, label: '市视角' },
];
/** 地图模式-枚举 */
export enum MapMode {
  /** 门店模式 */
  Store = 1,
  /** 城市模式 */
  City = 2,
  /** 省份模式 */
  Province = 3,
}
/** 地图模式-选项 */
export const mapModes = [
  { value: MapMode.Store, label: '门店模式' },
  { value: MapMode.City, label: '城市模式' },
  { value: MapMode.Province, label: '省份模式' },
];
/** 地图视角缩放级别 */
export enum MapViewZoom {
  /** 全国视角 */
  National = 5.04, // 首次加载时，地图显示的全国维度是5.04
  /** 省视角 */
  Province = 8,
  /** 市视角 */
  City = 10,
  /** 区视角 */
  District = 20,
}


export interface MockDemo {
  a: Function;
}
/* 图层zIndex大全，非hover，非开启工具集 */
export const layerBaseZIndex = {
  cityFull: 1020, // 城市全屏卡片  marker图层
  markAddress: 1010, // 标记   marker图层
  ownBrand: 1000, // 自有品牌  marker图层
  footPrint: 500, // 踩点记录点  marker图层
  competitiveBrand: 500, // 竞品品牌  mass图层
  digital3C: 500, // 小米3C  mass图层
  point: 10, // 围栏中心点位圆圈  几何图层
};
/* 图层zIndex大全，hover */
export const layerHoverZIndex = {
  markAddress: 1101, // 标记   marker图层
  ownBrand: 1101, // 自有品牌  marker图层
  footPrint: 1101, // 踩点记录点  marker图层
  competitiveBrand: 1101, // 竞品品牌  mass图层
  digital3C: 1101, // 小米3C  mass图层
};

export const layerCardHover = 2000;

export const HarmonyBrandId = 101077526; // 鸿蒙品牌id
export const AITOBrandId = 100427784; // 问界品牌id


/* 图层zIndex大全，开启工具集 */
// 汽车商圈 PointPolygon 固定 是10，处于最底部
export const toolSpecialOpenZIndex = {
  countryLayer: 120, // 全国矩形覆盖层   几何图形，仅为了让工具集可以点击穿透，无其他意义
  markAddress: 119, // 标记   marker图层
  ownBrand: 118, // 自有品牌  marker图层
  footPrint: 117, // 踩点记录点  marker图层
  // 海量点 需要低于110，才能被工具栏相关api穿透
  competitiveBrand: 109, // 竞品品牌  mass图层
  digital3C: 109, // 小米3C  mass图层
};

export const mapFilter = 'mapFilter';
export const zoomOfClick = 17;
export enum firstLevelCategoryCodesEnum{
  'SD' = 'SD', // 商业
  'CY' = 'CY', // 汽车
  'HOME' = 'HOME', // 小米之家
  'FOOT_PRINT' = 'FOOT_PRINT', // 踩点记录
}
/** 热力图枚举 */
export enum heatMapCodesEnum {
  'HEATMAP', // 热力图
  'LIVE', // 居住人口热力
  'PERMANENT', // 常驻人口热力
  'WORK', // 工作人口热力
  'CAR', // 汽车网点热力
  'MI_CAR', // 小米汽车保有量热力
  'MI_FANS', // 米粉热力
}

/**
 * @description 根据id匹配Marker
 * @param list MarkerList
 * @param id 匹配的id
 * @returns {marker,value}
 */
export const findMarkerById = (list:any[], id:number) => {
  const res:any = { marker: null, value: null };
  list.forEach((marker) => {
    const value = marker.getExtData();
    if (value.id === id) {
      res.marker = marker;
      res.value = value;
    }
  });
  return res;
};
export enum iconEnum {
  Digital3C = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_3c.png', // 3c
  Businessing = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_orange.png', // 已营业
  Constructing = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_gray.png', // 已决策
  BrandLogo = 'https://staticres.linhuiba.com/xiaomi/locationpc/selectionmap/brand-logo.png', // 竞品logo
  Digital3CCircle = 'https://staticres.linhuiba.com/xiaomi/locationpc/mi_icon_3c_circle_orange.png', // 3c 橙色圆点
}

export const businessRankOptions = [
  {
    label: '全部',
    value: -1,
  },
  {
    label: '前5',
    value: 5
  },
  {
    label: '前10',
    value: 10
  },
  {
    label: '前20',
    value: 20
  },
];

// 新增商圈的状态枚举
export enum newPointStatusEnum{
  NO_REVIEW=0, // 无需审核
  IN_REVIEW =1, // 待审核-审核中
  APPROVE = 2, // 审核通过
  REJECT = 9// 审核拒绝
}

// 数据给的热力，前面为范围大小(150m*150m)，后面为密度(每个间隔十几米)
export enum densityEnum {
  small= 3, // 整个城市（1km的网格）-- 目前没有该层级
  middle= 4, // 40km*20km（150米的网格）
  large=5, // 4km*2km（17米的网格）
};

export const showPolygonListKey = [
  `${firstLevelCategoryCodesEnum.CY}_rank`,
  `${firstLevelCategoryCodesEnum.CY}_name`,
  `${firstLevelCategoryCodesEnum.SD}_rank`,
  `${firstLevelCategoryCodesEnum.SD}_name`
];


/** 圈选查询数据对象 */
export interface drawSearchObjType {
  loadingObj: { // 圈选查询数据过滤，完成后会设为 true，优化抽屉空状态交互
    shops: Boolean;
  };
  /** 画框路径 */
  drawPath: Array<any>;
   /** 本品牌门店 */
  shops:Array<any>,
};

export function findNorthernmostCoordinate(lnglatArr: any[]) {
  if (lnglatArr?.length === 0) {
    return null;
  }
  // 初始化最北的经纬度为数组的第一个元素
  let northernmost = lnglatArr[0];
  // 遍历数组中的每个经纬度
  for (let i = 1; i < lnglatArr.length; i++) {
    // 如果当前经纬度的纬度值大于最北经纬度的纬度值
    if (lnglatArr[i][1] > northernmost[1]) {
      // 更新最北的经纬度
      northernmost = lnglatArr[i];
    }
  }
  return northernmost;
}
export const creating = 'creating';
export const collecting = 'collecting';
export const allData = 'allData';
export const rankOptions:any[] = [
  { key: creating, name: '生成中', value: creating },
  { key: collecting, name: '收藏', value: collecting },
  { key: 'rank', name: '全部', value: allData },
  { key: 'rank20', name: '前20名', value: 20 },
  { key: 'rank50', name: '前50名', value: 50 },
  { key: 'rank100', name: '前100名', value: 100 },
  { key: 'rank200', name: '前200名', value: 200 },
  { key: 'rank300', name: '前300名', value: 300 },
  { key: 'rank500', name: '前500名', value: 500 },
];
export const defaultSelectedRankOption = rankOptions[5];

export enum TabOption {
  /** 城市信息 */
  City = '1',
  /** 商圈信息 */
  Business = '2'
};
// 映射服务端返回的排序项
export enum ModelClusterSortRule {
  MarketScoreSort = 1, // 默认排序,即：市场评分排序
  IndustrySort, // 行业评分
  DistanceSort, // 距离排序
  ShoppingMallDailySort, // 商场日均客流排序
  Population500Sort, // 周边500m居住人口
  Population3000Sort, // 周边3km居住人口
}


// 筛选项枚举
export enum sectionKey {
  modelConfig='modelConfig', // 模型设置
  firstLevelCategory='firstLevelCategory', // 开店区域类型
  categoryMenu = 'categoryMenu', // 开店区域类型
  secondLevelCategoryCultureEducation='secondLevelCategoryCultureEducation', // 文教型
  secondLevelCategoryCommunity='secondLevelCategoryCommunity', // 社区型
  secondLevelCategoryTraffic='secondLevelCategoryTraffic', // 交通枢纽型
  secondLevelCategoryStreet='secondLevelCategoryStreet', // 街铺商圈型
  secondLevelCategoryOffice='secondLevelCategoryOffice', // 办公型
  secondLevelCategoryBusiness='secondLevelCategoryBusiness', // 商场型
  secondLevelCategoryScenicSpot='secondLevelCategoryScenicSpot', // 景区型
  secondLevelCategoryCompound='secondLevelCategoryCompound', // 复合型
  businessDistrictLevel='businessDistrictLevel', // 商圈等级
  area = 'area', // 行政区--no,
  districtMenu = 'districtMenu', // 行政区--no,
  labelSystemMall = 'labelSystemMall', // 开店区域标签
  labelSystemMenu='labelSystemMenu', // 开店区域标签-菜单
  labelSystemHighQuality = 'labelSystemHighQuality', // 商圈特性
  preferBrand='preferBrand',
  preferBrandMenu = 'preferBrandMenu', // 偏好品牌--no
  avoidBrand = 'avoidBrand', // 避开品牌--no
  avoidBrandMenu = 'avoidBrandMenu', // 避开品牌--no
  mallMenu='mallMenu', // 商圈特性菜单
  mallLevel='mallLevel', // 商场定位
  mallSize='mallSize', // 商场规模
  mallOpenYears='mallOpenYears', // 商场开业时长
  cateringMenu ='cateringMenu', // 餐饮门店菜单
  cateringStore = 'cateringStore', // 门店数
  oldCateringStore = 'oldCateringStore', // 存续门店3年老店比例
  residentsMenu = 'residentsMenu', // 居住人口菜单
  population = 'population', // 500m人口聚集度
  population3km = 'population3km', // 3km人口聚集度
  marketScore = 'marketScore', // 市场评分
  marketScoreMenu = 'marketScoreMenu', // 市场评分
  flowPortraitMenu='flowPortraitMenu', // 商场客流画像
  passFlow = 'passFlow', // 商场日均客流指数
  gender = 'gender', // 性别
  carProportion = 'carProportion', // 有车客群比例
  facility='facility', // 周边配套（500m）
  surroundingMenu = 'surroundingMenu', // 周边配套
  workType ='workType', // 办公
  schoolType = 'schoolType', // 学校
  trafficType='trafficType', // 交通
  scenicType='scenicType', // 景区
  medicalType ='medicalType', // 医院
  otherType = 'otherType', // 其他市场
  houseCharacteristicsMenu = 'houseCharacteristicsMenu', // 小区特性菜单
  households = 'households', // 小区户数
  housePrice = 'housePrice', // 周边房屋均价
  houseYear = 'houseYear', // 小区建筑年代
  tourBrand='tourBrand', // 巡展品牌
  tourBrandMenu='tourBrandMenu', // 巡展品牌
  developerBrand='developerBrand', // 开发商品牌
  labelSystemSource='labelSystemSource', // 来源
  labelSystemStandardChancePoint='labelSystemStandardChancePoint', // 机会点
  labelSystemSelfBrand='labelSystemSelfBrand', // 本品牌/门店覆盖
  labelSystemStandardTask='labelSystemStandardTask', // 拓店任务
  labelSystemPlanSpot='labelSystemPlanSpot', // 集客点
  labelSystemFavorites='labelSystemFavorites', // 收藏
  labelSystemSuitability='labelSystemSuitability', // 适合度
  favoriteMenu='favoriteMenu', // 收藏夹菜单
  favorite='favorite', // 收藏夹
  // ps：这里直接用枚举值会报错“Computed values are not permitted in an enum with string valued members.”
  // brand=layerSelectionEnum.SELF_BRAND_SHOP, // 本品牌门店
  brand=1, // 本品牌门店
  // competitorBrand=layerSelectionEnum.COMPETITION_BRAND, // 竞品品牌
  competitorBrand=2, // 竞品品牌
  // famousBrand=layerSelectionEnum.FAMOUS_BRAND, // 知名品牌
  famousBrand=3, // 知名品牌
  // collectArea=layerSelectionEnum.FAVORITES, // 收藏的开店区域
  collectArea=4, // 收藏的开店区域
  // community=layerSelectionEnum.HOUSE, // 图层设置-小区
  community=5, // 图层设置-小区
  openArea=6, // 开店区域
}
//  与modelCluster/es/selection/list中menuStructure的code一致
// 注意里面的字段不要随便更改，更改的时候一定要确认影响范围！！！
export const useLeftSection = () => {

  /** 获取开店区域别名 */
  const openingAreaAlias = useGlobalAlias('openingArea');

  return [
    { label: `${openingAreaAlias}类型`, code: sectionKey.categoryMenu, remark: `多样化${openingAreaAlias}选择，轻松定位您的目标${openingAreaAlias}`,
      children: [
        { label: '商业区', code: sectionKey.secondLevelCategoryBusiness },
        // { label: '文教型', code: sectionKey.secondLevelCategoryCultureEducation },
        // { label: '社区型', code: sectionKey.secondLevelCategoryCommunity },
        // { label: '交通枢纽型', code: sectionKey.secondLevelCategoryTraffic },
        // { label: '街铺商圈型', code: sectionKey.secondLevelCategoryStreet },
        // { label: '办公型', code: sectionKey.secondLevelCategoryOffice },
        // { label: '景区型', code: sectionKey.secondLevelCategoryScenicSpot	 },
        // { label: '复合型', code: sectionKey.secondLevelCategoryCompound	 },
        { label: '其他', code: sectionKey.firstLevelCategory },
        { label: '商圈等级', code: sectionKey.businessDistrictLevel },
      ]
    },
    // { label: '行政区', code: sectionKey.districtMenu, remark: '筛选特定行政区域，精准定位选址布局',
    //   children: [
    //     { label: '行政区', code: sectionKey.area, remark: '筛选特定行政区域，精准定位选址布局', }
    //   ]
    // },
    {
      label: `${openingAreaAlias}标签`, code: sectionKey.labelSystemMenu, remark: `利用细分标签，快速识别${openingAreaAlias}特色`,
      children: [
        // 20240606版本先隐藏  规划：标签还是要做的功能，6月下的版本中，重点优化开店区域标签

        { label: '门店覆盖', code: sectionKey.labelSystemSelfBrand, },
        { label: '集客点', code: sectionKey.labelSystemPlanSpot, },
        { label: '拓店任务', code: sectionKey.labelSystemStandardTask, },
        { label: '机会点', code: sectionKey.labelSystemStandardChancePoint, },
        { label: '收藏', code: sectionKey.labelSystemFavorites, },
        { label: '来源', code: sectionKey.labelSystemSource, },
        { label: '适合度', code: sectionKey.labelSystemSuitability, },
      ]
    },
    // { label: '开发商品牌', code: 'developerBrandMenu', remark: '查询所属开发品牌的商场', children: [
    //   { label: '开发商品牌', code: 'developerBrand', }
    // ] },
    {
      label: '商场特性', code: sectionKey.mallMenu, remark: `利用细分标签，快速识别${openingAreaAlias}特色，轻松定位您的目标商场`,
      children: [
        { label: '商场定位', code: sectionKey.mallLevel, },
        { label: '商场规模', code: sectionKey.mallSize, },
        { label: '商场开业时长', code: sectionKey.mallOpenYears, },
      ]
    },
    {
      label: '商场客流画像', code: sectionKey.flowPortraitMenu, remark: `查询符合客流人群画像的${openingAreaAlias}`,
      children: [
        { label: '日均客流', code: sectionKey.passFlow, },
        { label: '性别', code: sectionKey.gender, },
        // { label: '年龄', code: 'age', }, // 设计缺陷 0606版本隐藏掉
        { label: '有车客群比例', code: sectionKey.carProportion, },
      ]
    },
    { label: '偏好品牌', code: sectionKey.preferBrandMenu, remark: `查询周边500m有此品牌的${openingAreaAlias}`, children: [
      { label: '偏好品牌', code: sectionKey.preferBrand, }
    ] },
    { label: '避开品牌', code: sectionKey.avoidBrandMenu, remark: `避开周边500m有此品牌的${openingAreaAlias}`, children: [
      { label: '避开品牌', code: sectionKey.avoidBrand, }
    ] },
    // { label: '多经点位', code: 'multiplePointsMenu', remark: '查询拥有以下条件的巡展点位商场',
    //   children: [
    //     { label: '历史是否有汽车巡展', code: 'historyCarTour', },
    //     { label: '场地面积', code: 'pointArea', },
    //     { label: '类型', code: 'locationType', },
    //     { label: '楼层', code: 'floor', },
    //   ]
    // },
    // { label: '巡展品牌', code: sectionKey.tourBrandMenu, remark: `历史在${openingAreaAlias}开过快慢闪店的品牌`, children: [
    //   { label: '巡展品牌', code: sectionKey.tourBrand }
    // ] }, // todo-需要重新请求
    // // { label: '巡展车型', code: '', remark: '历史在商圈开过快慢闪店的车型',
    // //   children: [
    // //     { label: '价格', code: '' },
    // //     { label: '能源', code: '' }
    // //   ]
    // // }, // todo 巡展车型 整个二级筛选都还没有--目前不做
    { label: '小区特性', code: sectionKey.houseCharacteristicsMenu, remark: `查询周边500m小区特性符合要求的${openingAreaAlias}`,
      children: [
        { label: '小区户数', code: sectionKey.households },
        { label: '小区房价', code: sectionKey.housePrice },
        { label: '建筑年代', code: sectionKey.houseYear },
      ]
    },
    { label: '居住人口', code: sectionKey.residentsMenu, remark: '根据周边500m、3km内居住人口筛选',
      children: [
        { label: '500m人口聚集度', code: sectionKey.population },
        { label: '3km人口聚集度', code: sectionKey.population3km },
      ]
    },
    { label: '周边配套', code: sectionKey.surroundingMenu, remark: `查询中心点周边500m内有此配套的${openingAreaAlias}`,
      children: [
        { label: '办公', code: sectionKey.workType },
        { label: '学校', code: sectionKey.schoolType },
        { label: '交通', code: sectionKey.trafficType },
        { label: '景区', code: sectionKey.scenicType },
        { label: '医院', code: sectionKey.medicalType },
        { label: '其他市场', code: sectionKey.otherType },
      ]
    },
    { label: '市场评分', code: sectionKey.marketScoreMenu, remark: `衡量${openingAreaAlias}竞争力的关键指标，分数越高代表整体市场表现越好`, children: [
      { label: '市场评分', code: sectionKey.marketScore, }
    ] },
    { label: '餐饮门店', code: sectionKey.cateringMenu, remark: '餐饮门店和餐饮老店占比合并',
      children: [
        { label: '门店数', code: sectionKey.cateringStore },
        { label: '存续门店3年老店比例', code: sectionKey.oldCateringStore },
      ]
    },
    { label: '收藏夹', code: sectionKey.favoriteMenu, remark: '收藏夹',
      children: [
        { label: '收藏夹', code: sectionKey.favorite },
      ]
    },
  ];
};

export function resetDynamic(selection, value) {
  const newValue = { ...value };
  // 是否存在“商圈类型”
  if (selection.menuStructure.find(item => item.encode === sectionKey.categoryMenu)) {
    const newFirstOptionIds = selection[sectionKey.firstLevelCategory].map(item => item.id);
    const newFirstValue = newValue[sectionKey.firstLevelCategory].filter(item => newFirstOptionIds.includes(item));
    const newSecondOptionIds = selection[sectionKey.secondLevelCategoryBusiness].map(item => item.id);
    const newSecondValue = newValue[sectionKey.secondLevelCategoryBusiness].filter(item => newSecondOptionIds.includes(item));
    newValue[sectionKey.firstLevelCategory] = newFirstValue;
    newValue[sectionKey.secondLevelCategoryBusiness] = newSecondValue;
    if (!selection[sectionKey.businessDistrictLevel]?.length) { // 如果不存在商圈等级
      newValue[sectionKey.businessDistrictLevel] = [];
    }
  } else {
    newValue[sectionKey.firstLevelCategory] = [];
    newValue[sectionKey.secondLevelCategoryBusiness] = [];
    newValue[sectionKey.businessDistrictLevel] = []; // 商圈等级
  }
  // 不存在“商圈标签”，这里必须写死，因为 res和返回的selection里都已经可能没有labelSystemMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.labelSystemMenu)) {
    newValue[sectionKey.labelSystemSelfBrand] = []; // 本品牌/门店覆盖
    newValue[sectionKey.labelSystemPlanSpot] = []; // 集客点
    newValue[sectionKey.labelSystemStandardTask] = []; // 拓店任务
    newValue[sectionKey.labelSystemStandardChancePoint] = []; // 机会点
    newValue[sectionKey.labelSystemFavorites] = []; // 收藏
    newValue[sectionKey.labelSystemSource] = []; // 来源
    newValue[sectionKey.labelSystemSuitability] = []; // 适合度
  } else {
    if (!selection[sectionKey.labelSystemSelfBrand]?.length) { // 如果不存在本品牌/门店覆盖
      newValue[sectionKey.labelSystemSelfBrand] = [];
    }
    if (!selection[sectionKey.labelSystemPlanSpot]?.length) { // 如果不存在集客点
      newValue[sectionKey.labelSystemPlanSpot] = [];
    }
    if (!selection[sectionKey.labelSystemStandardTask]?.length) { // 如果不存在拓店任务
      newValue[sectionKey.labelSystemStandardTask] = [];
    }
    if (!selection[sectionKey.labelSystemStandardChancePoint]?.length) { // 如果不存在机会点
      newValue[sectionKey.labelSystemStandardChancePoint] = [];
    }
    if (!selection[sectionKey.labelSystemFavorites]?.length) { // 如果不存在收藏
      newValue[sectionKey.labelSystemFavorites] = [];
    }
    if (!selection[sectionKey.labelSystemSource]?.length) { // 如果不存在来源
      newValue[sectionKey.labelSystemSource] = [];
    }
    if (!selection[sectionKey.labelSystemSuitability]?.length) { // 如果不存在适合度
      newValue[sectionKey.labelSystemSuitability] = [];
    }
  }
  // 不存在“商圈特性”，这里必须写死，因为 res和返回的selection里都已经可能没有mallMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.mallMenu)) {
    newValue[sectionKey.mallLevel] = []; // 商场定位
    newValue[sectionKey.mallSize] = []; // 商场规模
    newValue[sectionKey.mallOpenYears] = []; // 商场开业市场
  } else {
    if (!selection[sectionKey.mallLevel]?.length) { // 如果不存在商场定位
      newValue[sectionKey.mallLevel] = [];
    }
    if (!selection[sectionKey.mallSize]?.length) { // 如果不存在商场规模
      newValue[sectionKey.mallSize] = [];
    }
    if (!selection[sectionKey.mallOpenYears]?.length) { // 如果不存在商场开业市场
      newValue[sectionKey.mallOpenYears] = [];
    }
  }

  // 不存在“客流画像”，这里必须写死，因为 res和返回的selection里都已经可能没有flowPortraitMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.flowPortraitMenu)) {
    newValue[sectionKey.passFlow] = []; // 商场日均客流指数
    newValue[sectionKey.gender] = []; // 性别
    newValue[sectionKey.carProportion] = []; // 有车客群比例
  } else {
    if (!selection[sectionKey.passFlow]?.length) { // 如果不存在商场日均客流指数
      newValue[sectionKey.passFlow] = [];
    }
    if (!selection[sectionKey.gender]?.length) { // 如果不存在性别
      newValue[sectionKey.gender] = [];
    }
    if (!selection[sectionKey.carProportion]?.length) { // 如果不存在有车客群比例
      newValue[sectionKey.carProportion] = [];
    }
  }
  // 不存在“偏好品牌”，这里必须写死，因为 res和返回的selection里都已经可能没有preferBrandMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.preferBrandMenu)) {
    newValue[sectionKey.preferBrand] = [];
  }
  // 不存在“避开品牌”，这里必须写死，因为 res和返回的selection里都已经可能没有avoidBrandMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.avoidBrandMenu)) {
    newValue[sectionKey.avoidBrand] = [];
  }
  // 不存在“小区特性”，这里必须写死，因为 res和返回的selection里都已经可能没有houseCharacteristicsMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.houseCharacteristicsMenu)) {
    newValue[sectionKey.households] = []; // 小区户数
    newValue[sectionKey.housePrice] = []; // 周边房屋均价
    newValue[sectionKey.houseYear] = []; // 小区建筑年代
  } else {
    if (!selection[sectionKey.households]?.length) { // 如果不存在小区户数
      newValue[sectionKey.households] = [];
    }
    if (!selection[sectionKey.housePrice]?.length) { // 如果不存在周边房屋均价
      newValue[sectionKey.housePrice] = [];
    }
    if (!selection[sectionKey.houseYear]?.length) { // 如果不存在小区建筑年代
      newValue[sectionKey.houseYear] = [];
    }
  }
  // 不存在“居住人口”，这里必须写死，因为 res和返回的selection里都已经可能没有residentsMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.residentsMenu)) {
    newValue[sectionKey.population] = []; // 500m人口聚集度
    newValue[sectionKey.population3km] = []; // 3km人口聚集度
  } else {
    if (!selection[sectionKey.population]?.length) { // 如果不存在500m人口聚集度
      newValue[sectionKey.population] = [];
    }
    if (!selection[sectionKey.population3km]?.length) { // 如果不存在3km人口聚集度
      newValue[sectionKey.population3km] = [];
    }
  }
  // 不存在“周边配套”，这里必须写死，因为 res和返回的selection里都已经可能没有surroundingMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.surroundingMenu)) {
    newValue[sectionKey.workType] = []; // 办公
    newValue[sectionKey.schoolType] = []; // 学校
    newValue[sectionKey.trafficType] = []; // 交通
    newValue[sectionKey.scenicType] = []; // 景区
    newValue[sectionKey.medicalType] = []; // 医院
    newValue[sectionKey.otherType] = []; // 其他市场
  } else {
    if (!selection[sectionKey.workType]?.length) { // 如果不存在办公
      newValue[sectionKey.workType] = [];
    }
    if (!selection[sectionKey.schoolType]?.length) { // 如果不存在学校
      newValue[sectionKey.schoolType] = [];
    }
    if (!selection[sectionKey.trafficType]?.length) { // 如果不存在交通
      newValue[sectionKey.trafficType] = [];
    }
    if (!selection[sectionKey.scenicType]?.length) { // 如果不存在景区
      newValue[sectionKey.scenicType] = [];
    }
    if (!selection[sectionKey.medicalType]?.length) { // 如果不存在医院
      newValue[sectionKey.medicalType] = [];
    }
    if (!selection[sectionKey.otherType]?.length) { // 如果不存在其他市场
      newValue[sectionKey.otherType] = [];
    }
  }
  // 不存在“市场评分”，这里必须写死，因为 res和返回的selection里都已经可能没有marketScoreMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.marketScoreMenu)) {
    newValue[sectionKey.marketScore] = [];
  } else {
    if (!selection[sectionKey.marketScore]?.length) { // 如果不存在市场评分
      newValue[sectionKey.marketScore] = [];
    }
  }
  // 不存在“餐饮门店”，这里必须写死，因为 res和返回的selection里都已经可能没有cateringMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.cateringMenu)) {
    newValue[sectionKey.cateringStore] = []; // 门店数
    newValue[sectionKey.oldCateringStore] = []; // 存续门店3年老店比例
  } else {
    if (!selection[sectionKey.cateringStore]?.length) { // 如果不存在门店数
      newValue[sectionKey.cateringStore] = [];
    }
    if (!selection[sectionKey.oldCateringStore]?.length) { // 如果不存在存续门店3年老店比例
      newValue[sectionKey.oldCateringStore] = [];
    }
  }
  // 不存在“收藏夹”，这里必须写死，因为 res和返回的selection里都已经可能没有cateringMenu了
  if (!selection.menuStructure.find(item => item.encode === sectionKey.favoriteMenu)) {
    newValue[sectionKey.favorite] = []; // 收藏夹
  }
  return newValue;
}
// 鼠标滑过地图时，hover后需要请求接口的场景，最小停留时间(单位：ms)后才开始接口请求。
export const HOVER_STAY_TIME = 300;

/**
 * @description 根据城市id寻找对应的城市信息
 * @param provincesCities store中的provincesCities数据
 * @param cityId 当前城市id
 * @returns 城市信息（附带所在省份部分数据）
 */
export const findCurCItyInfo = (provincesCities, cityId) => {
  let city;
  provincesCities?.forEach((province) => {
    province?.children?.forEach((item) => {
      if (item.id === cityId) {
        city = {
          ...item,
          provinceName: province?.name,
          provinceId: province?.id,
          pinyin: province?.pinyin,
        };
      }
    });
  });
  return city;
};

export enum XTCLabel {
  'A' = 'https://staticres.linhuiba.com/project-custom/locationpc/xtc/xtc_label_A@2x.png',
  'B' = 'https://staticres.linhuiba.com/project-custom/locationpc/xtc/xtc_label_B@2x.png',
  'C' = 'https://staticres.linhuiba.com/project-custom/locationpc/xtc/xtc_label_C@2x.png',
  'D' = 'https://staticres.linhuiba.com/project-custom/locationpc/xtc/xtc_label_D@2x.png',
  'S' = 'https://staticres.linhuiba.com/project-custom/locationpc/xtc/xtc_label_S@2x.png',
};

// 处理来源（又名新增商圈）
function handleUserCustomFlag(filter) {
  const ids = filter.newShopsCircle[sectionKey.labelSystemSource];
  if (ids?.length > 1 || !ids?.length) {
    return undefined;
  } else {
    return ids[0] === 2; // 新增时true，推荐是false
  }
};

export const getBusinessCircleParams = (filter) => {
  const _params: any = {};
  const modelConfigId = filter.newShopsCircle?.[sectionKey.modelConfig]?.[0];
  if (modelConfigId) {
    // 模型id
    _params.modelConfigId = modelConfigId;

    const firstLevelCategories = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.firstLevelCategory] || [] : []; // 一级商圈类型
    const secondLevelCategories = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.secondLevelCategoryBusiness] || [] : []; // 二级商圈类型-仅商场型
    // firstLevelCategories 和 secondLevelCategories如果同时是空数组的时候，接口层面目前是相当于全选
    _params.firstLevelCategories = firstLevelCategories;
    _params.secondLevelCategories = secondLevelCategories;

    const businessDistrictLevels = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.businessDistrictLevel] || [] : []; // 商圈等级
    _params.businessDistrictLevels = businessDistrictLevels;

    /* 商圈标签 */
    const selfBrandTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemSelfBrand] || [] : []; // 本品牌/门店覆盖
    const standardTaskTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemStandardTask] || [] : []; // 拓店任务
    const standardChancePointTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemStandardChancePoint] || [] : []; // 机会点
    const userCustomFlag = filter.shopsLayer ? handleUserCustomFlag(filter) : undefined; // 来源
    const planSpotTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemPlanSpot] || [] : []; // 集客点
    const favoritesTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemFavorites] || [] : []; // 标签：收藏
    const suitabilities = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.labelSystemSuitability] || [] : []; // 适合度
    _params.selfBrandTypes = selfBrandTypes;
    _params.standardTaskTypes = standardTaskTypes;
    _params.standardChancePointTypes = standardChancePointTypes;
    _params.userCustomFlag = userCustomFlag;
    _params.planSpotTypes = planSpotTypes;
    _params.favoritesTypes = favoritesTypes;
    _params.suitabilities = suitabilities;

    /* 商场特性 */
    const mallLevels = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.mallLevel] || [] : []; // 商场定位
    const mallSizes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.mallSize] || [] : []; // 商场规模
    const mallOpenYearsList = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.mallOpenYears] || [] : []; // 商场开业时长
    _params.mallLevels = mallLevels;
    _params.mallSizes = mallSizes;
    _params.mallOpenYearsList = mallOpenYearsList;

    /* 商场客流画像 */
    const mallPassFlowTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.passFlow] || [] : []; // 日均客流
    const genders = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.gender] || [] : []; // 性别
    const carProportions = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.carProportion] || [] : []; // 有车客群比例
    _params.mallPassFlowTypes = mallPassFlowTypes;
    _params.genders = genders;
    _params.carProportions = carProportions;

    /* 偏好品牌 */
    const preferBrandIds = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.preferBrand] || [] : [];
    _params.preferBrandIds = preferBrandIds;

    /* 避开品牌 */
    const avoidBrandIds = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.avoidBrand] || [] : [];
    _params.avoidBrandIds = avoidBrandIds;

    /* 小区特性 */
    const householdsTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.households] || [] : []; // 小区户数
    const housePriceTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.housePrice] || [] : []; // 周边房屋均价
    const houseYearTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.houseYear] || [] : []; // 小区建筑年代
    _params.householdsTypes = householdsTypes;
    _params.housePriceTypes = housePriceTypes;
    _params.houseYearTypes = houseYearTypes;

    /* 居住人口 */
    const populationTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.population] || [] : []; // 500m人口聚集度
    const population3kmTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.population3km] || [] : []; // 3km人口聚集度
    _params.populationTypes = populationTypes;
    _params.population3kmTypes = population3kmTypes;

    /* 周边配套 */
    const workTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.workType] || [] : []; // 办公
    const schoolTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.schoolType] || [] : []; // 学校
    const trafficTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.trafficType] || [] : []; // 交通
    const scenicTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.scenicType] || [] : []; // 景区
    const medicalTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.medicalType] || [] : []; // 医院
    const otherTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.otherType] || [] : []; // 其他市场
    _params.workTypes = workTypes;
    _params.schoolTypes = schoolTypes;
    _params.trafficTypes = trafficTypes;
    _params.scenicTypes = scenicTypes;
    _params.medicalTypes = medicalTypes;
    _params.otherTypes = otherTypes;

    /* 市场评分 */
    const marketScoreTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.marketScore] || [] : [];
    _params.marketScoreTypes = marketScoreTypes;

    /* 餐饮门店 */
    const cateringStoreTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.cateringStore] || [] : []; // 门店数
    const oldCateringStoreTypes = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.oldCateringStore] || [] : []; // 存续门店3年老店比例
    _params.cateringStoreTypes = cateringStoreTypes;
    _params.oldCateringStoreTypes = oldCateringStoreTypes;

    /* 收藏夹 */
    const favoriteIds = filter.shopsLayer ? filter.newShopsCircle?.[sectionKey.favorite] || [] : [];
    _params.favoriteIds = favoriteIds;
  }
  return _params;
};
